import OrderLinks from "src/composables/OrderLinks";
import ServiceLocation from "src/composables/ServiceLocation";

const generate_affiliate_link = function (supabase_user) {
  const { order_link } = OrderLinks();
  const { service_location } = ServiceLocation();

  const original_url = new URL(order_link.value);
  const tracking_base_url = "https://comparepower.com/work-pap-deep/orderlink";
  const params = original_url.searchParams;

  const first_name = params.get('first_name') || '';
  const last_name = params.get('last_name') || '';
  const esiid = params.get('esiid');

  const tracking_url = new URL(tracking_base_url + '/order/service_location');

  params.forEach((value, key) => {
    tracking_url.searchParams.set(key, value);
  });

  if (first_name || last_name) {
    tracking_url.searchParams.set('data1', `${first_name} ${last_name}`.trim());
  }

  if (esiid) {
    const address_parts = [
      esiid,
      service_location.value.address,
      service_location.value.address_overflow,
      service_location.value.city,
      service_location.value.zip_code
    ].filter(Boolean);

    tracking_url.searchParams.set('data2', address_parts.join(' '));
  }

  if (supabase_user.value?.user_metadata?.affiliate) {
    const afid = supabase_user.value.user_metadata.affiliate.cp_afid;
    const afbid = supabase_user.value.user_metadata.affiliate.cp_afbid;

    if (afid) tracking_url.searchParams.set('cp_afid', afid);
    if (afbid) tracking_url.searchParams.set('cp_afbid', afbid);
  }

  return tracking_url.toString();
};

export default () => {
  return {
    generate_affiliate_link
  };
};
